import type { OpportunityMonthlySale } from 'backend/types'

export function filterSales(sales: OpportunityMonthlySale[], searchText: string): OpportunityMonthlySale[] {
  if (!searchText.trim()) return sales

  const lowerSearch = searchText.toLowerCase()
  return sales.filter((sale) => {
    const searchableFields = [
      sale.sales_id,
      sale.salesforce_customer_name,
      sale.salesforce_project_name,
      sale.salesforce_original_project_name,
    ]
    return searchableFields.some((field) =>
      String(field || '')
        .toLowerCase()
        .includes(lowerSearch),
    )
  })
}
